/**
 * Parse storefront search queries for Lilliput-specific intent (screen size).
 * Shopify's default tokenizer matches bare "8" to titles like "Q15-8K", so size
 * queries are rewritten to use product tags / metafield filters instead.
 */
window.LdSearchIntent = (function () {
  const SIZE_PATTERN =
    /(?<![\d.])(\d{1,2})(?:\.\d+)?\s*(?:["”]|inch(?:es)?\b|in\b|-inch\b)/i;

  const GENERIC_WORDS = new Set([
    'a',
    'and',
    'broadcast',
    'display',
    'displays',
    'for',
    'in',
    'inch',
    'inches',
    'monitor',
    'monitors',
    'of',
    'screen',
    'screens',
    'the',
    'video',
    'with',
  ]);

  const SCREEN_SIZE_FILTER = 'filter.p.m.lilliput.screen_size';

  function parse(rawQuery) {
    const query = String(rawQuery || '').trim().replace(/\s+/g, ' ');
    const match = query.match(SIZE_PATTERN);

    if (!match) {
      return {
        query,
        sizeInches: null,
        sizeTag: null,
        sizeFilterValue: null,
        remainder: query,
        predictiveQuery: query,
        needsSizeFilter: false,
      };
    }

    const inches = Math.floor(Number.parseFloat(match[1]));
    if (!Number.isFinite(inches) || inches <= 0) {
      return {
        query,
        sizeInches: null,
        sizeTag: null,
        sizeFilterValue: null,
        remainder: query,
        predictiveQuery: query,
        needsSizeFilter: false,
      };
    }

    const remainder = query
      .replace(SIZE_PATTERN, ' ')
      .replace(/["”]/g, ' ')
      .split(/\s+/)
      .filter((word) => word && !GENERIC_WORDS.has(word.toLowerCase()))
      .join(' ');

    const sizeTag = `${inches}-inch`;
    const sizeFilterValue = `${inches} inch`;
    const predictiveQuery = remainder ? `tag:${sizeTag} ${remainder}` : `tag:${sizeTag}`;

    return {
      query,
      sizeInches: inches,
      sizeTag,
      sizeFilterValue,
      remainder,
      predictiveQuery,
      needsSizeFilter: true,
    };
  }

  function searchPath() {
    return window.routes?.search_url || '/search';
  }

  function buildSearchUrl(rawQuery, extraParams) {
    const intent = typeof rawQuery === 'string' ? parse(rawQuery) : rawQuery;
    const params = new URLSearchParams();

    params.set('q', intent.query);
    params.set('options[prefix]', 'last');

    if (extraParams) {
      Object.entries(extraParams).forEach(([key, value]) => {
        if (value != null && value !== '') params.set(key, value);
      });
    }

    if (intent.needsSizeFilter) {
      params.set(SCREEN_SIZE_FILTER, intent.sizeFilterValue);
    }

    return `${searchPath()}?${params.toString()}`;
  }

  function currentUrlNeedsSizeFilter() {
    if (!window.location.pathname.endsWith('/search') && window.location.pathname !== '/search') {
      return false;
    }

    const params = new URLSearchParams(window.location.search);
    const intent = parse(params.get('q') || '');
    if (!intent.needsSizeFilter) return false;
    if (params.get(SCREEN_SIZE_FILTER) === intent.sizeFilterValue) return false;
    return true;
  }

  function enforceSizeFilterInUrl() {
    if (!currentUrlNeedsSizeFilter()) return false;
    const params = new URLSearchParams(window.location.search);
    const intent = parse(params.get('q') || '');
    const next = buildSearchUrl(intent, {
      sort_by: params.get('sort_by') || undefined,
    });
    window.location.replace(next);
    return true;
  }

  return {
    SCREEN_SIZE_FILTER,
    parse,
    buildSearchUrl,
    enforceSizeFilterInUrl,
  };
})();

window.LdSearchIntent.enforceSizeFilterInUrl();
